(function () {

  // Nur auf der Startseite ausführen
  if (window.location.pathname !== '/') {
    return;
  }

  function createContactLinks() {

    // E-Mail aus einzelnen Bestandteilen zusammensetzen
    var email = [
      'antikhalle',
      '-dresden',
      '@',
      'gmx',
      '.de'
    ].join('');

    // Telefonnummer zusammensetzen
    var phone = [
      '0172',
      '3542197'
    ].join(' ');

    var phoneTel = [
      '+49',
      '172',
      '3542197'
    ].join('');

    /*
     * Alle Textknoten der Seite durchsuchen.
     * Dadurch funktioniert es auch innerhalb von <strong>,
     * <p>, <div> usw.
     */
    var walker = document.createTreeWalker(
      document.body,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode: function (node) {

          var parent = node.parentElement;

          if (!parent) {
            return NodeFilter.FILTER_REJECT;
          }

          // Script- und Style-Inhalte nicht bearbeiten
          if (
            parent.tagName === 'SCRIPT' ||
            parent.tagName === 'STYLE'
          ) {
            return NodeFilter.FILTER_REJECT;
          }

          // Nur unsere beiden Platzhalter bearbeiten
          if (
            node.nodeValue.indexOf('E-Mail-KONTAKT') !== -1 ||
            node.nodeValue.indexOf('TELEFON-KONTAKT') !== -1
          ) {
            return NodeFilter.FILTER_ACCEPT;
          }

          return NodeFilter.FILTER_REJECT;
        }
      }
    );

    var nodes = [];

    while (walker.nextNode()) {
      nodes.push(walker.currentNode);
    }

    nodes.forEach(function (node) {

      var text = node.nodeValue;

      /*
       * E-Mail
       */
      if (text.indexOf('E-Mail-KONTAKT') !== -1) {

        var emailLink = document.createElement('a');

        emailLink.href = 'mailto:' + email;
        emailLink.textContent = email;

        var emailFragment = document.createDocumentFragment();

        var emailParts = text.split('E-Mail-KONTAKT');

        emailParts.forEach(function (part, index) {

          if (part) {
            emailFragment.appendChild(
              document.createTextNode(part)
            );
          }

          if (index < emailParts.length - 1) {
            emailFragment.appendChild(emailLink);
          }
        });

        node.parentNode.replaceChild(
          emailFragment,
          node
        );
      }

      /*
       * Telefonnummer
       */
      else if (text.indexOf('TELEFON-KONTAKT') !== -1) {

        var phoneLinkElement = document.createElement('a');

        phoneLinkElement.href = 'tel:' + phoneTel;
        phoneLinkElement.textContent = phone;

        var phoneFragment = document.createDocumentFragment();

        var phoneParts = text.split('TELEFON-KONTAKT');

        phoneParts.forEach(function (part, index) {

          if (part) {
            phoneFragment.appendChild(
              document.createTextNode(part)
            );
          }

          if (index < phoneParts.length - 1) {
            phoneFragment.appendChild(phoneLinkElement);
          }
        });

        node.parentNode.replaceChild(
          phoneFragment,
          node
        );
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      createContactLinks
    );
  } else {
    createContactLinks();
  }

})();